import React from 'react';

// eslint-disable-next-line max-len
const ELEMIS = '/themes/theme/elemis/logo.png';
const ELEMIS_DARK_LOGO = '/themes/theme/elemis/logo.png';

const ElemisTheme = {
  headerLogo: {
    src: ELEMIS,
    alt: 'Elemis Logo',
    size: 40,
  },
  darkLogo: {
    src: ELEMIS_DARK_LOGO,
    alt: 'Elemis Logo',
    size: 40,
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '4px solid #000',
    height: 80,
  },
  title: 'Elemis',
  isLightOnDark: false,
  organisationId: 'df27f0a0-7ad2-4161-b14e-f928b464a85b',
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="60"
        src={ELEMIS} alt="Elemis Logo"
      />
      <br /><br />
    </div>
  ),
  shareSite: 'https://share.elemis.com',
};

export default ElemisTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/elemis-main.js
 **/